module.exports = __webpack_public_path__ + "static/app-store-badge-894fe300b1299988257458f1ae36418d.svg";